import { ColumnsType } from "antd/es/table"
import { TeamTableDropdown } from "./TeamTableDropdown"
import type { IUsersTable } from "types/table.type"
import { BadgeUserRole } from "components/ui/bandges/BadgeUserRole/BadgeUserRole"

export const TeamTableColumns = () => {
	const columns: ColumnsType<IUsersTable> = [
		{
			title: "NAME",
			dataIndex: "name",
			render: (name) => <div data-testid="name">{name}</div>,
		},
		{
			title: "EMAIL",
			dataIndex: "email",
			render: (email) => <div data-testid="email">{email}</div>,
		},
		{
			title: "ROLE",
			render: (record) => (
				<div data-testid="role">
					<BadgeUserRole role={record.role} status={record.status} />
				</div>
			),
		},
		{
			title: "",
			render: (record) => {
				return record.role === "Super Admin" ? null : (
					<div data-testid="actions">
						<TeamTableDropdown availableRoles={record.availableRoles} availableStatus={record.status} record={record} />
					</div>
				)
			},
		},
	]

	return columns
}
